/* eslint-disable newline-after-var */
// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ActionsPopover from '../../../shared/components/actions-popover';
import AuditPreparation from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import {FormattedMessage} from 'react-intl';
import {buildAuditDealerString} from '../../shared/services/build-audit-dealer-string.js';
import {getPrintAuditOptions} from '../../shared/services/get-print-audit-options';

const isDisabled = auditPreparation =>
    auditPreparation.claims.filter(claim => !claim.isSystemSelected).length < auditPreparation.userSelectedClaimsMinimum;

const queryString = accounts =>
    accounts.join('&d=');

function handleOnClick() {

    this.onSaveAudit();

}

function handlePrintClaimsButtonClick() {

    this.onPrintClaimsButton();

}

function handlePrintCreditMemoButtonClick() {

    this.onPrintCreditMemoButton();

}

const PrepareAuditHeader = props => {

    const options = getPrintAuditOptions(props::handlePrintClaimsButtonClick, props::handlePrintCreditMemoButtonClick);

    return (

        <header className='prepare-audit-header'>
            <FormattedMessage
                id='PREPARING_AUDIT_FOR_WITH_DEALER'
                values={{dealer: buildAuditDealerString(props.auditPreparation.leadAccountName, props.auditPreparation.city, props.auditPreparation.state)}}
            />
            <section className='buttons'>
                <a
                    className='secondary'
                    href='#/tcsm/audits'
                >
                    <FormattedMessage id='CANCEL'/>
                </a>
                <div className='actions-button'>
                    <ActionsPopover
                        icon={'PDF'}
                        label={'PRINT'}
                        options={options}
                        showButtonIcon={true}
                    />
                </div>
                {props.isAuditLoaded &&
                    <div className='add-save-button-group'>
                        <a
                            className='secondary'
                            href={`#/tcsm/audits/prepare/claims?d=${queryString(props.auditPreparation.accounts)}`}
                        >
                            <FormattedMessage id='ADD_CLAIM'/>
                        </a>
                        <button
                            className='button-primary'
                            disabled={isDisabled(props.auditPreparation)}
                            onClick={props::handleOnClick}
                        >
                            <FormattedMessage id='SAVE_AUDIT'/>
                        </button>
                    </div>
                }
            </section>
        </header>

    );

};
PrepareAuditHeader.displayName = 'PrepareAuditHeader';
PrepareAuditHeader.propTypes = {
    auditPreparation: PropTypes.instanceOf(AuditPreparation).isRequired,
    isAuditLoaded: PropTypes.bool.isRequired,
    onPrintClaimsButton: PropTypes.func.isRequired,
    onPrintCreditMemoButton: PropTypes.func.isRequired,
    onSaveAudit: PropTypes.func.isRequired
};

export default PrepareAuditHeader;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/prepare-audit-header.js